module.exports = __webpack_public_path__ + "img/short-stories.3946684e.jpg";